export function getColumns(isPublisher:boolean) {
  const columns = [
      ...(isPublisher ? [] : [{
      name: 'Order ref',
      key: 'orderRef',
      selector: (row:any) => row.orderRef,
      sortable: true,wrap: true,
      }]),
      {
          name: 'Network',
          key:'network',
          selector: (row:any) => row.network,
          sortable: true,
          wrap: true,
          searchable:true
        },
        {
          name: 'Country',
          key:'country',
          selector: (row:any) => row.country,
          sortable: true,
          wrap: true,
          searchable: true
        },
        {
          name: 'Campaign',
          key: 'campaignName',
          selector: (row:any) => row.campaignName,
          sortable: true,
          wrap: true,
          searchable:true
        },
        ...(isPublisher ? [] : [{
          name: 'Affiliate',
          key: 'affiliateName',
          selector: (row:any) => row.affiliateName,
          sortable: true,
          wrap: true,
          searchable:true
        }]),
    {
      name: 'Status',
      key: 'status',
      selector: (row:any) => row.status,
      sortable: true,
      wrap: true, 
      searchable:true,
    },
    ...(isPublisher ? [] : [{
      name: 'Amount',
      key: 'orderAmount',
      selector: (row:any) => row.orderAmount,
      sortable: true,wrap: true,
    }]),
    {
      name: isPublisher ? 'Commission' : 'Cost',
      key: 'commission',
      selector: (row:any) => row.commission,
      sortable: true,wrap: true,
    },
    {
      name: 'Reference',
      key: 'ref',
      selector: (row:any) => row.ref,
      sortable: true,
      wrap: true,
      searchable:true
    },
    {
      name: 'Date',
      key: 'date',
      selector: (row:any) => row.formattedDate,
      sortable: true,
      wrap: true,
      id:'date',
      searchable:true
    },
  ]
  return columns
}